import { JobStatus } from 'src/models/IJob'

/**
 * Chip label for a run status (MEL-568).
 *
 * Statuses render in upper case (matching the backend enum), except a
 * successful run which reads "SUCCESS" instead of "COMPLETE".
 */
const STATUS_LABELS: Partial<Record<JobStatus, string>> = {
    [JobStatus.Complete]: 'SUCCESS',
}

export const statusLabel = (status: JobStatus): string =>
    STATUS_LABELS[status] ?? status

/**
 * Logs can be downloaded once a run has started — while it is running (a
 * snapshot of the log so far) or after it has finished. A queued run has no
 * logs yet.
 */
export const canDownloadLogs = (status: JobStatus): boolean =>
    status !== JobStatus.Queued

export const LOGS_DOWNLOAD_UNAVAILABLE_MESSAGE = 'Logs can be downloaded once the run has started'
